import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page door-info-page"
};
const _hoisted_2 = {
  key: 0,
  class: "info"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "device-name ellipsis"
};
const _hoisted_5 = {
  class: "label"
};
const _hoisted_6 = {
  class: "label"
};
import { onMounted, ref } from "vue";
import { closeToast, showLoadingToast } from "vant";
import { getDoorOpenList } from "@/api/mini";
export default /*@__PURE__*/_defineComponent({
  __name: 'info',
  setup(__props) {
    const list = ref([]);
    const refreshing = ref(false);
    // 开门状态 0 成功 1 失败 2 未执行（适配自小程序 filter.wxs）
    const tagColor = (status = 0) => {
      if (status == 2) return "warning";
      if (status == 1) return "danger";
      return "success";
    };
    const statusText = (status = 0) => {
      if (status == 1) return "失败";
      if (status == 2) return "未执行";
      return "成功";
    };
    const loadList = async () => {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const res = await getDoorOpenList();
        list.value = (res === null || res === void 0 ? void 0 : res.data) || [];
      } finally {
        closeToast();
      }
    };
    const onRefresh = async () => {
      try {
        await loadList();
      } finally {
        refreshing.value = false;
      }
    };
    onMounted(() => {
      void loadList();
    });
    return (_ctx, _cache) => {
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => refreshing.value = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.deviceName), 1), _createVNode(_component_van_tag, {
            type: tagColor(item.status)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(statusText(item.status)), 1)]),
            _: 2
          }, 1032, ["type"])]), _createElementVNode("div", _hoisted_5, "操作人员：" + _toDisplayString(item.operName), 1), _createElementVNode("div", _hoisted_6, "操作时间：" + _toDisplayString(item.openTime), 1)]);
        }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          description: "暂无数据"
        }))]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});